export const routesAiAsistan = [
  {
    path: "/ai-asistan",
    name: "ai-asistan",
    component: () => import("@/views/ai_asistan/index.vue"),
    meta: {
      public: false,
      title: "aiAsistan.baslik",
      yetki: { k: [1350002] },
    },
  },
]
